import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { environment } from '../../../environments/environment';
import { FeedbackMessage } from './types';
import moment from 'moment';
import { SharedService } from 'src/app/shareModule/services/shared.service';

@Component({
  selector: 'app-manual-reviews-two',
  templateUrl: './manual-reviews-two.component.html',
  styleUrls: ['./manual-reviews-two.component.scss']
})
export class ManualReviewsTwoComponent implements OnInit {
  checkAdminStatus: any;
  user_id: number;
  edit_review_link: any;
  edit_client_desc: any;
  share_link: any;
  addEmailFG: FormGroup;
  updateEmailFG: FormGroup;
  editFG: FormGroup;
  send_Message: FormGroup;
  imageUploadForm: FormGroup;
  submitted = false;
  subAdminData: any;
  hideAdminData: any;
  getallname: any;
  show_review_link: any;
  show_client_desc: any;
  is_clicked_name: number;
  google_feedbacks: any;
  googlecoundata: any;
  admindatawithid: any;
  link_url: any = environment.baseUrl + `client-review-share`
  user_link_url: any = environment.baseUrl + `#/review-image-upload`
  edit_google_review: number;
  edit_google_feedbacks: any;
  reviewData: any;
  get_all_feedback_URL: any;
  url_names: any;
  sendsmsid: any;
  review_link: any;
  feedbackDataForSms: any;
  feedbackDescription: any;
  feedbackMessages: Array<FeedbackMessage>;
  getallname_unsent: any;
  inboxID: any;
  getLatestPhone: any;
  image_upload_link: string;
  user_share_review_link: string;
  saveSubadnminid: any;
  imagepreview: any;
  img: File;
  imgUrl = environment.ImageUrl;
  gfbid: any;
  is_approved: any;
  feedbackmessagesObj: any;
  is_approved_message: string;
  is_paid: any;
  is_paid_message: string;
  flag: any;

  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private router: Router,
    private modalService: NgbModal,
    private local: LocalServiceService,
    private fb: FormBuilder,
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {
    if (this.sharedService.isBrowser()) {
      this.checkUserType();
      this.get_admin_All_Req();

      if (this.admindatawithid != 0) {
        this.get_feedback_subadmin_google(this.admindatawithid);
      } else {
        this.get_feedback_subadmin_google(0);
      }

      this.addEmailFG = this.fb.group({
        userName: ['', [Validators.required]],
        email: ['', [Validators.required]],
        no_of_review: ['', [Validators.required]]
      });

      this.updateEmailFG = this.fb.group({
        // name: ['', [Validators.required]],
        email: ['', [Validators.required]],
        client_desc: ['', [Validators.required]],
        // no_of_review: ['', [Validators.required]]
        no_of_review: ['']
      });

      this.editFG = new FormGroup({
        // feedbackNameurl: new FormControl(''),
        // feedbackName: new FormControl(''),
        description: new FormControl(''),
        client_remarks: new FormControl(''),
        user_remarks: new FormControl(''),
        // star: new FormControl(''),
      });

      this.send_Message = this.fb.group({
        phone: ["", [Validators.required]],
        name: ["", [Validators.required]],
        amount: ["", [Validators.required]],
        nameId: ["", [Validators.required]],
      })

      this.imageUploadForm = this.fb.group({
        remark: [""],
        // subadminid: ["", [Validators.required]],
      })
    }
  }

  get addEmailFG_v() { return this.addEmailFG.controls }

  get updateEmailFG_v() { return this.updateEmailFG.controls }

  get send_Message_v() { return this.send_Message.controls }

  get imageUploadForm_v() { return this.imageUploadForm.controls }

  checkUserType() {
    let x = localStorage.getItem("user");
    let admintype = JSON.parse(x)
    this.checkAdminStatus = admintype.userType
  }

  addUserEmail(content: string, id: number, type: any, reviewData: any) {
    console.log(reviewData, "here");
    if (type == 2) {
      this.user_id = id
      const reviewCount = reviewData.feedback_google_twos.length
      this.edit_review_link = reviewData.feedback_google_twos.length > 0 ? reviewData.feedback_google_twos[reviewCount - 1].review_link : "";
      this.edit_client_desc = reviewData.feedback_google_twos.length > 0 ? reviewData.feedback_google_twos[reviewCount - 1].client_desc : "";
      this.updateEmailFG.patchValue({
        email: this.edit_review_link,
        client_desc: this.edit_client_desc
      });
      this.share_link = reviewData ? reviewData.link : ""
    }
    this.modalService.open(content, {
      backdropClass: 'light-blue-backdrop',
      size: 'sm',
      // backdrop: 'static',
    });
  }

  createReviewLoop(number: number) {
    const numArray = [5, 10, 15, 20, 30, 50, 100]
    return numArray
  }

  add_user_email_data() {
    this.submitted = true;
    if (this.addEmailFG.invalid) {
      return false;
    }

    this.auth
      .add_manual_review_user_2(this.addEmailFG.value)
      .subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.ngOnInit();
          this.modalService.dismissAll();
        },
        (e) => {
          if (e.status == 400) {
            this.toastr.error(e.error.message);
          }
        }
      );
  }

  update_user_email_data() {
    this.submitted = true;
    if (this.updateEmailFG.invalid) {
      return false;
    }
    // return
    console.log("here");
    /* const reqObj = {
      ...this.addEmailFG.value
    } */
    console.log(this.updateEmailFG.value, '---this.addEmailFG.value---');

    this.updateEmailFG.value.user_id = this.user_id
    this.show_client_desc = this.updateEmailFG.value?.client_desc;
    this.auth
      .edit_review_user_2(this.updateEmailFG.value)
      .subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.ngOnInit();
          // this.getDataByUser(this.user_id, response.body)

          this.modalService.dismissAll();
        },
        (e) => {
          if (e.status == 400) {
            this.toastr.error(e.error.message);
          }
        }
      );
  }

  getDataByUser(id, reviewData) {
    console.log(reviewData, '---reviewData--');

    // return // add to stop
    this.flag = id;
    this.admindatawithid = id;
    const reviewCount = reviewData.feedback_google_twos.length;
    this.show_review_link = reviewData.feedback_google_twos.length > 0 ? reviewData.feedback_google_twos[reviewCount - 1].review_link : "";
    this.show_client_desc = reviewData.feedback_google_twos.length > 0 ? reviewData.feedback_google_twos[reviewCount - 1].client_desc : "";
    this.share_link = reviewData ? reviewData.link : "";
    this.is_clicked_name = 1;
    this.get_feedback_subadmin_google(this.admindatawithid)
    // this.get_specific_feedback_manager_url(this.admindatawithid);
  }

  get_feedback_subadmin_google(data) {
    this.auth.get_feedback_subadmin_google_2(data).subscribe(
      (response: any) => {
        this.google_feedbacks = response.body;

        console.log(this.google_feedbacks, '----this.google_feedbacks----');

        this.googlecoundata = this.google_feedbacks.length
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  /* get_specific_feedback_manager_url(id) {
    this.auth.get_specific_feedback_manager_url(id).subscribe(
      (response: any) => {
        this.url_names = response.body.c;

      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/']);
        }
      }
    );
  } */

  editReview(content: string, id: number, feedback) {
    this.edit_google_review = id;
    this.auth.edit_feedback_subadmin_google_2(id).subscribe(
      (response: any) => {
        this.edit_google_feedbacks = response.body.edit_feedback_subadmin_google;
        this.reviewData = response.body.data
        this.modalService.open(content, {
          backdropClass: 'light-blue-backdrop',
          size: 'sm',
          // backdrop: 'static',
        });

        this.editFG.patchValue({
          feedbackNameurl: "",
          feedbackName: this.edit_google_feedbacks.feedbackName,
          description: this.edit_google_feedbacks.description != null ? this.edit_google_feedbacks.description : "",
          client_remarks: this.edit_google_feedbacks.client_remarks != null ? this.edit_google_feedbacks.client_remarks : "",
          user_remarks: this.edit_google_feedbacks.user_remarks != null ? this.edit_google_feedbacks.user_remarks : "",
          star: this.edit_google_feedbacks.star == 0 ? 5 : this.edit_google_feedbacks.star,
        });
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  update_edit_google_feedbacks() {
    this.auth
      .update_edit_google_feedbacks_2(this.editFG.value, this.edit_google_review)
      .subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.ngOnInit();
          this.modalService.dismissAll();
        },
        (e) => {
          if (e.status == 400) {
            this.toastr.error(e.error.message);
          }
        }
      );
  }

  sendsms(phone: number, id, description, review_link, feedbackData) {
    this.sendsmsid = id;
    this.review_link = review_link;
    this.feedbackDataForSms = feedbackData;
    console.log(this.feedbackDataForSms, '----name-----111----');
    this.feedbackDescription = description;
    const sentfeedbackmessages = feedbackData.feedbackmessages
    console.log(sentfeedbackmessages, '--------sentfeedbackmessages--------');

    this.auth.getSmsFeedback_2(id).subscribe(messages => {
      this.feedbackMessages = messages.body;
      this.getAllNameOther(feedbackData.ratingByUserId)

      debugger;
      this.modalService.open(phone, {
        backdropClass: 'light-blue-backdrop',
        size: 'sm',
        // backdrop: 'static',
      });
      this.inboxID = id;
    })
  }

  onSelectName(value: any, name: any): void {
    console.log(value, '--value---');
    this.getLatestPhone = value
    let nameData = this.getallname.filter(data => data.phno == value)
    nameData = nameData.length > 0 ? nameData[0] : {}
    console.log(nameData, '---nameData---');
    // this.selectedName = value;
    this.send_Message.patchValue({
      phone: value,
      name: nameData.name,
      amount: nameData.amount,
      nameId: nameData.id,
    });
  }

  sendMessage() {
    this.submitted = true;
    if (this.send_Message.invalid) {
      return false;
    }
    let sendata = {
      ...this.send_Message.value,
      gfbid: this.sendsmsid,
    };
    if (this.feedbackDescription.trim() == '') {
      return this.toastr.error('Please add review.');
    }
    if (this.review_link.trim() == '') {
      return this.toastr.error('Please add review link.');
    }
    // this.image_upload_link = `https://myvip.asia/#/review-image-upload/${btoa(this.sendsmsid)}/${btoa(this.getLatestPhone)}`;
    this.image_upload_link = `https://myvip.asia/#/review-image-upload?id=${btoa(this.sendsmsid)}&phone=${btoa(this.getLatestPhone)}&manual_type=${btoa('2')}`;
    this.user_share_review_link = `https://myvip.asia/#/user-review-share?u=${btoa(this.getLatestPhone)}`;
    if (this.image_upload_link.trim() == '') {
      return this.toastr.error('Please add image upload link.');
    }
    console.log(this.image_upload_link, '----this.image_upload_link-----');

    console.log(sendata, '----sendata-----');

    this.auth.sendSmsFeedback_additional_2(sendata, this.feedbackDescription, this.review_link, this.image_upload_link, this.user_share_review_link).subscribe(
      (response: any) => {
        this.get_feedback_subadmin_google(this.admindatawithid);
        this.toastr.success('Message sent successfully');
        this.modalService.dismissAll();
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        } else if (error.status == 400) {
          this.toastr.error(error.error.message)
        }
      }
    );
  }

  getAllNameOther(sub_admin_id) {
    this.auth.getnameByAdminOther_2(sub_admin_id).subscribe(
      (response: any) => {
        console.log(this.feedbackDataForSms, '----name-----2222----');
        console.log(response.body.getnameByAdmin, '---response.body.getnameByAdmin----');
        // this.getallname = response.body.getnameByAdmin
        this.getallname_unsent = response.body.getnameByAdmin
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  saveFeedbackApproval(content, gfbid, is_approved, feedbackmessagesObj, type) {
    this.gfbid = gfbid
    this.is_approved = is_approved
    this.feedbackmessagesObj = feedbackmessagesObj
    console.log(this.feedbackmessagesObj, '----this.feedbackmessagesObj---');

    this.is_approved_message = is_approved == 1 ? 'Approve?' : 'Dis-approve?'
    if (type == 1) {
      this.modalService.open(content, { size: 'sm', backdrop: 'static' });
    } else {
      let nameData = this.getallname.filter(data => data.phno == feedbackmessagesObj.phone && data.name == feedbackmessagesObj.name)
      nameData = nameData.length > 0 ? nameData[0] : {}
      console.log(nameData, '----nameData-------');
      // return
      const saveObj = {
        gfbid,
        is_approved,
        feedback_msg_id: feedbackmessagesObj.id
      }
      // update approval
      this.auth.saveFeedbackApproval_2(saveObj).subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.ngOnInit();
          this.modalService.dismissAll();
        },
        (error) => {
          if (error.status == 401) {
            this.local.logout();
            this.router.navigate(['/admin']);
          }
        }
      );
    }

  }

  saveFeedbackPayment(content, gfbid, is_paid, feedbackmessagesObj, type) {
    this.gfbid = gfbid
    this.is_paid = is_paid
    this.feedbackmessagesObj = feedbackmessagesObj
    console.log(this.feedbackmessagesObj, '----this.feedbackmessagesObj---');

    this.is_paid_message = is_paid == 1 ? 'Approve?' : 'Dis-approve?'
    if (type == 1) {
      this.modalService.open(content, { size: 'sm', backdrop: 'static' });
    } else {
      let nameData = this.getallname.filter(data => data.phno == feedbackmessagesObj.phone && data.name == feedbackmessagesObj.name)
      nameData = nameData.length > 0 ? nameData[0] : {}
      console.log(nameData, '----nameData-------');
      // return
      const saveObj = {
        gfbid,
        is_paid,
        feedback_msg_id: feedbackmessagesObj.id
      }
      // update approval
      this.auth.saveFeedbackPayment_2(saveObj).subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.ngOnInit();
          this.modalService.dismissAll();
        },
        (error) => {
          if (error.status == 401) {
            this.local.logout();
            this.router.navigate(['/admin']);
          }
        }
      );
    }

  }

  get_admin_All_Req() {
    this.auth.get_other_admin_All_Req_2().subscribe(
      (response: any) => {
        // this.google_feedbacks = response.body;
        this.subAdminData = []
        this.hideAdminData = []
        // this.url_names = response.body.c;
        // const adminNameArray = response.body.b.getnameByAdmin
        // console.log(this.feedbackDataForSms,'----name----121212-----');
        this.getallname = response.body.b.getnameByAdmin;

        response.body.a.map((e) => {
          if (e.hideUser == 0) {
            e.link = `${this.link_url}?c=${btoa(e.id)}`
            // e.link = `${this.link_url}?c=${btoa(e.id)}`
            this.subAdminData.push(e)
          } else {
            e.link = `${this.link_url}?c=${btoa(e.id)}`
            // e.link = `${this.link_url}?c=${btoa(e.id)}`
            this.hideAdminData.push(e)
          }
        })
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  imageUpload(content: string, id: number) {
    this.getimagdata(id)
    // this.SubAdminNameSelect();
    // this.getAllname();
    this.saveSubadnminid = id
    this.modalService.open(content, { size: 'sm', backdrop: 'static' });
    // this.verify_review(id)
  }


  viewlimage(content: string, id) {
    this.getimagdata(id)
    this.saveSubadnminid = id
    this.modalService.open(content, { size: 'sm', backdrop: 'static' });
    // this.verify_review(id)


  }

  getimagdata(id) {
    this.auth.get_feedbackimagedata_2(id).subscribe(
      (response: any) => {
        this.imagepreview = response.body?.image
        console.log(this.imagepreview, '---this.imagepreview');

      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  onFileChanged(event) {
    this.img = event.target.files[0];
  }

  verify_review_token() {
    this.submitted = true;
    if (this.imageUploadForm.invalid) {
      return false;
    }
    const { subadminid, remark } = this.imageUploadForm.value

    const formData = new FormData()
    formData.append("image", this.img)
    // formData.append("subadminid", subadminid)
    formData.append("remark", "")
    formData.append("saveSubadnminid", this.saveSubadnminid)
    this.auth.reviewImageUploadForm_2(formData).subscribe(
      (response: any) => {
        // this.subAdmainName = response.body;
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );

    this.verify_review(this.saveSubadnminid)
    this.modalService.dismissAll();
  }

  verify_review(id: number) {
    this.auth.verify_feedback_subadmin_google_2(id).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.ngOnInit();
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  update_circle(id) {
    this.auth
      .update_circle_2({ is_circle: 1 }, id)
      .subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.ngOnInit();
          this.modalService.dismissAll();
        },
        (e) => {
          if (e.status == 400) {
            this.toastr.error(e.error.message);
          }
        }
      );
  }

  unhide(even, status) {
    // return // add to stop
    this.hideuserfunction(parseInt(even), status)
  }
  hideURL(id, status) {
    // return // add to stop
    this.hideuserfunction(id, status)
  }

  hideuserfunction(id, status) {
    // hideUser
    this.auth.hideGoogelreview(id, status).subscribe(
      (response: any) => {
        // this.getadminlistdata()
        this.get_admin_All_Req()
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  copyToClipboardMessage() {
    this.toastr.success('Copied');
  }

  formateDate(date: number) {
    return moment(date * 1000).format("DD/MM/YYYY hh:mm a");
  }

}
